import { PlaceType } from "../types/warehouse.types";
import { Translate } from 'react-admin';

/**
 * Map PlaceType int to enum string key
 */
export const placeTypeKeys: Record<PlaceType, string> = {
  [PlaceType.EPL_BPL]: 'EPL_BPL',
  [PlaceType.EPL]: 'EPL',
  [PlaceType.BPL]: 'BPL',
};

/**
 * Get place type display name from enum value with translation
 * @param placeType - The PlaceType enum value
 * @param t - Translation function from useTranslate hook
 * @returns Translated place type name or undefined
 */
export function getPlaceTypeName(placeType: number | null | undefined, t: Translate): string | undefined {
  if (placeType === null || placeType === undefined) {
    return undefined;
  }

  if (!(placeType in placeTypeKeys)) {
    return undefined;
  }

  const key = placeTypeKeys[placeType as PlaceType];
  return t(`osfc.enums.place_type.${key}`);
}
